var render, staticRenderFns
import script from "./button-container.vue?vue&type=script&lang=js"
export * from "./button-container.vue?vue&type=script&lang=js"
import style0 from "./button-container.vue?vue&type=style&index=0&id=6d4911e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4911e5",
  null
  
)

export default component.exports